"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTealiumCompliantString = void 0;
/**
 * Funktion formatiert den String zu LowerCase, ersetzt alle Leerzeichen durch Unterstriche und ersetzt Sonderzeichen
 * und Umlaute durch eine Tealium-kompatible Schreibweise.
 *
 * @category Utils
 * @param input
 * @param options
 */
const formatTealiumCompliantString = (input, options) => {
    var _a;
    if (!input) {
        return '';
    }
    const delimiter = (_a = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _a !== void 0 ? _a : '_';
    return input
        .toLowerCase()
        .replaceAll('+', 'plus')
        .replaceAll('*', 'stern')
        .replaceAll('°', 'grad')
        .replaceAll('€', 'euro')
        .replaceAll('é', 'e')
        .replaceAll('m²', 'qm')
        .replaceAll('α', 'alpha')
        .replaceAll('´', '-')
        .replaceAll("''", 'zoll')
        .replaceAll('%', 'prozent')
        .replaceAll('$', 'dollar')
        .replaceAll('"', 'zoll')
        .replaceAll('ä', 'ae')
        .replaceAll('ö', 'oe')
        .replaceAll('ü', 'ue')
        .replaceAll('ß', 'ss')
        .replaceAll("'", '-')
        .replaceAll(/\s/g, delimiter) // Replace whitespaces with delimiter
        .replaceAll(/[^a-zA-Z0-9]/g, delimiter) // Replace special characters with delimiter
        .replaceAll(new RegExp(`${delimiter}+`, 'g'), delimiter) // Replace multiple delimiter with one delimiter
        .replace(new RegExp(`^${delimiter}+|${delimiter}+$`, 'g'), ''); // Trim delimiter
};
exports.formatTealiumCompliantString = formatTealiumCompliantString;
